import React, { useEffect } from 'react'
import { useModalContext } from '../context/ModalContext'

function Modal() {
  const { showModal, setShowModal, data, setData } = useModalContext()
  useEffect(() => {
     var modal = document.getElementById('myModal')
  
 
    if(showModal) {
      modal.style.display = 'block'
      setShowModal(true)
    }
    else{
      modal.style.display = 'none'
      setShowModal(false)
    } 

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = 'none'
      setShowModal(false)
    }
    }
  })

  return (
    <>
      <div id="myModal" className="modal">
        <div className="modal-content">
          <span className="close" onClick={() => setShowModal(false)}>x</span>
            <img src={data} />
        </div>
      </div>
    </>
  )
}

export default Modal
